import * as React from 'react';
import { useLayoutEffect } from 'react';

export default function useResizeObserver<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T | null>,
  onResize: (el: T | null) => void,
) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      onResize(entry.target as T);
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, onResize]);
}
